// extracted by mini-css-extract-plugin
export default {"chat":"chat__TsvKF","textbox":"textbox__TUvB7","speaker":"speaker__QR9+c","typing":"typing__+XB8E","emph":"emph__Kq7E1","disabled":"disabled__Kj1Qj"};